import CommonModal from "@components/ui-components/modal";
import CreatableInput from "@components/fields/react-select/creatable-input";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import { Link } from "react-router-dom";
import SingleDatePicker from "@components/fields/date-picker/single-picker";
import useMeetingsUpsert from "./use-meetings-upsert";
import { useTranslation } from "react-i18next";

export const UpsertMeetings = ({
    getEvents,
    modalConfig,
    toggleModal,
    isEdit
}) => {
    const { methods, loading, onSubmit } = useMeetingsUpsert({
        getEvents,
        modalConfig,
        toggleModal,
        isEdit
    });
    const {
        control,
        watch,
        formState: { errors }
    } = methods;

    const { t } = useTranslation();

    const content = [
        {
            leftChild: {
                title: "Enter Basic Details",
                desc : "Enter the basic details of the meeting which you wish to create"
            },
            rightChild: (
                <>
                    <InputField
                        id="title"
                        name="title"
                        label="Title"
                        control={control}
                        errors={errors}
                        required/>
                    <InputField
                        id="description"
                        name="description"
                        label="Description"
                        type="textarea"
                        control={control}
                        errors={errors}
                        required/>
                    <InputField
                        id="location"
                        name="location"
                        label="Location"
                        control={control}
                        errors={errors}/>
                    <CreatableInput
                        required
                        id="attendees"
                        name="attendees"
                        label="Attendees"
                        control={control}
                        errors={errors}/>
                    <SingleDatePicker
                        id="start"
                        name="start"
                        label="Start"
                        required
                        control={control}
                        format="MMMM d, yyyy h:mm a"
                        errors={errors}
                        minDate={new Date()}
                        showTimeSelect/>
                    <SingleDatePicker
                        id="end"
                        name="end"
                        label="End"
                        required
                        control={control}
                        format="MMMM d, yyyy h:mm a"
                        errors={errors}
                        minDate={watch("start")}
                        showTimeSelect/>
                </>
            )
        }
    ];

    return (
        <CommonModal
            isOpen={modalConfig.open}
            confirmButton={{
                txt    : isEdit ? "Update" : "Add",
                icon   : "content-save",
                onClick: onSubmit,
                loading
            }}
            type="extraLarge"
            extraFooterItems={
                isEdit ? (
                    <>
                        <Link target="_blank" to={modalConfig.row.hangoutLink}>
                            {t("Join Meeting")}
                        </Link>
                        <Link target="_blank" to={modalConfig.row.link}>
                            {t(" View Calendar")}
                        </Link>
                    </>
                ) : null
            }
            handleModal={toggleModal}
            title={`${isEdit ? "Edit" : "Add"} Meeting`}
            body={<FormView content={content} />}/>
    );
};
